module.exports = __webpack_public_path__ + "static/media/19-6.fe8541f9.mp3";